import { ROUTER } from "../helpers/RouterApi";
import { BackEndHelper } from "../helpers/BackEndHelper";
import typing from "../helpers/typing";

export const IdentifySupplierJobsServices = {
  getList,
  getDetails,
  getCategories,
  getKeywords,
  postStatusChangeList,
  getLocations,
  postUrls,
  postCrawlUrls,
  getKeywordsFound,
  GetReasonsForDiscarded
};

function getList(filters) {
  let setFilters = {};

  if (!typing.isEmpty(filters.domain)) {
    const domain = { domain: filters.domain };
    Object.assign(setFilters, domain);
  }

  if (!typing.isEmpty(filters.categories) && filters.categories.length > 0) {
    const categories = {
      categories: filters.categories.map(function (item) {
        return item.IDCATEGORY;
      }),
    };
    Object.assign(setFilters, categories);
  }

  if (!typing.isEmpty(filters.keywords) && filters.keywords.length > 0) {
    const keywords = {
      keywords: filters.keywords.map(function (item) {
        return item.IDKEYWORD;
      }),
    };
    Object.assign(setFilters, keywords);
  }

  if (!typing.isEmpty(filters.keywordsFound) && filters.keywordsFound.length > 0) {
    const keywordsFound = {
      keywordsFound: filters.keywordsFound.map(function (item) {
        return item.IDKEYWORD;
      }),
    };
    Object.assign(setFilters, keywordsFound);
  }

  if (!typing.isEmpty(filters.locations) && filters.locations.length > 0) {
    const locations = { locations: filters.locations };
    Object.assign(setFilters, locations);
  }

  if (!typing.isEmpty(filters.supplier)) {
    const supplier = { supplier: filters.supplier };
    Object.assign(setFilters, supplier);
  }

  if (!typing.isEmpty(filters.idStatus)) {
    const idStatus = { idStatus: filters.idStatus };
    Object.assign(setFilters, idStatus);
  }

  if (!typing.isEmpty(filters.beginDate)) {
    const beginDate = { beginDate: typing.convertToDateShortMonth(filters.beginDate) };
    Object.assign(setFilters, beginDate);
  }

  if (!typing.isEmpty(filters.endDate)) {
    const endDate = { endDate: typing.convertToDateShortMonth(filters.endDate) };
    Object.assign(setFilters, endDate);
  }

  if (!typing.isEmpty(filters.page)) {
    const page = { page: filters.page };
    Object.assign(setFilters, page);
  }

  if (!typing.isEmpty(filters.pageSize)) {
    const pageSize = { pageSize: filters.pageSize };
    Object.assign(setFilters, pageSize);
  }

  return BackEndHelper.request("GET", ROUTER.ROUTE_API_IDENTIFY_SUPPLIER_JOBS, setFilters);
}

function getDetails(ididentifysupplierjob) {
  let data = {
    ididentifysupplierjob: ididentifysupplierjob,
  };
  return BackEndHelper.request("GET", ROUTER.ROUTE_API_IDENTIFY_SUPPLIER_JOBS_DETAILS, data);
}

function getCategories(category) {
  let data = {};
  if (!typing.isEmpty(category)) {
    const categories = { category: category };
    Object.assign(data, categories);
  }
  return BackEndHelper.request("GET", ROUTER.ROUTE_API_IDENTIFY_SUPPLIER_JOBS_CATEGORIES_RELATED, data);
}

function getKeywords(keyword) {
  let data = {};
  if (!typing.isEmpty(keyword)) {
    const keywords = { keyword: keyword }; 
    Object.assign(data, keywords);
  }
  return BackEndHelper.request("GET", ROUTER.ROUTE_API_IDENTIFY_SUPPLIER_JOBS_KEYWORDS_RELATED, data);
}

function getKeywordsFound(keyword) {
  let data = {};
  if (!typing.isEmpty(keyword)) {
    const keywords = { keyword: keyword }; 
    Object.assign(data, keywords);
  }
  return BackEndHelper.request("GET", ROUTER.ROUTE_API_IDENTIFY_SUPPLIER_JOBS_KEYWORDS_RELATED_FOUND, data);
}

function getLocations() {
  return BackEndHelper.request("GET", ROUTER.ROUTE_API_IDENTIFY_SUPPLIER_JOBS_LOCATIONS);
}

function postStatusChangeList(statusChangeList) {
  let requestData = {
    IdStatus: statusChangeList.IdStatus,
    KeyValues: statusChangeList.KeyValues,
    IdReasonDiscarded: statusChangeList.IdReasonDiscarded
  };
  return BackEndHelper.request("POST", ROUTER.ROUTE_API_IDENTIFY_SUPPLIER_JOBS, requestData, true);
}

function postUrls(urls) {
  return BackEndHelper.request("POST", ROUTER.ROUTE_API_IDENTIFY_SUPPLIER_JOBS_URLS, urls, true);
}

function postCrawlUrls(urls) {
  return BackEndHelper.request("POST", ROUTER.ROUTE_API_IDENTIFY_SUPPLIER_JOBS_CRAWl_URLS, urls, true);
}

function GetReasonsForDiscarded() {
  return BackEndHelper.request("GET", ROUTER.ROUTE_API_IDENTIFY_SUPPLIER_JOBS_REASON_DISCARDED);
}
